import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  ListGroupItem,
  Input,
  Label,
} from 'reactstrap';

const AdminUserEditNotificationsItem = ({
  notificationId,
  notification,
  channels,
  enabledChannels,
  handleNotificationChange,
}) => (
  <ListGroupItem className={`list-group-item-notification-${notificationId}`}>
    <div className="notification-label">
      {notification.description}
    </div>
    <div className="switch-group">
      {Object.keys(channels).map(channel => (
        <Label
          key={`key-${notificationId}-${channel}`}
          className={classnames('switch', { disabled: !enabledChannels.includes(channel) })}
          htmlFor={`notification-channel-${notificationId}-${channel}`}
        >
          {channels[channel]}
          <div className="switch-control input-inner">
            <Input
              type="checkbox"
              name={`notification-channel-${notificationId}-${channel}`}
              id={`notification-channel-${notificationId}-${channel}`}
              value={true}
              checked={notification.channels[channel]}
              disabled={!enabledChannels.includes(channel)}
              onChange={() => {
                handleNotificationChange(notificationId, channel);
              }}
            />
            <i />
          </div>
        </Label>
      ))}
    </div>
  </ListGroupItem>
);

AdminUserEditNotificationsItem.propTypes = {
  notificationId: PropTypes.string.isRequired,
  notification: PropTypes.object.isRequired,
  channels: PropTypes.object.isRequired,
  enabledChannels: PropTypes.array.isRequired,
  handleNotificationChange: PropTypes.func.isRequired,
};

export default AdminUserEditNotificationsItem;
